"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMediaPath = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
/**
 * Get full path for media content on device.
 * Prioritise user selected media over template set media.
 * @param content
 * @param contentMetadata
 */
var getMediaPath = function (mediaKeys, key, content, contentMetadata) {
    var _a;
    // media set in template editor
    var templateSrc = key ? mediaKeys[key] : undefined;
    if (!content || !contentMetadata || !(0, seesignage_utils_1.isMediaInfopageContent)(content)) {
        return templateSrc;
    }
    return ((_a = contentMetadata[content.key]) === null || _a === void 0 ? void 0 : _a.fullPath) || templateSrc;
};
exports.getMediaPath = getMediaPath;
//# sourceMappingURL=infopages.js.map